import api from '../../services/api';
import { useState, useEffect } from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import { Link } from 'react-router-dom';
import PageContainer from '../../common/components/PageContainer';
import PageHeader from '../../common/components/PageHeader';
import { statusOSInfo, tipoServicoLabel } from './osLabels';

function OS() {
    const [textoPesquisa, setTextoPesquisa] = useState("");
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/os/pesquisa?texto=${textoPesquisa}&page=${page - 1}`);
                setData(response.data.content);
                setTotalPages(response.data.page.totalPages);
            } catch (error) {
                console.error("Erro ao buscar dados das ordens de serviço:", error);
            }
        }
        fetchData();
    }, [page, textoPesquisa]);

    const handleChange = (event, value) => {
        setPage(value);
    };

    return (
        <PageContainer>
            <PageHeader
                title="Ordem de Serviço"
                searchValue={textoPesquisa}
                onSearchChange={(e) => {
                    setPage(1);
                    setTextoPesquisa(e.target.value);
                }}
                actionLabel="Adicionar Ordem de Serviço"
                actionIcon={<AddCircleOutlineIcon />}
                actionTo="/os/cadastro"
            />

            <Grid container spacing={2}>
                {data.map((os) => {
                    const status = statusOSInfo(os.status);
                    return (
                        <Grid item xs={12} sm={6} md={4} key={os.id}>
                            <Card>
                                <CardActionArea component={Link} to={`/os/${os.id}`}>
                                    <CardContent>
                                        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                <AssignmentOutlinedIcon color="primary" fontSize="small" />
                                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                                    {os.numeroOs || 'OS sem número'}
                                                </Typography>
                                            </Stack>
                                            <Chip size="small" label={status.label} color={status.color} />
                                        </Stack>
                                        <Typography variant="body2" sx={{ mb: 0.5 }}>{os.descricao}</Typography>
                                        <Typography variant="body2" color="text.secondary">Empresa: {os.empresa}</Typography>
                                        <Typography variant="body2" color="text.secondary">Local: {os.local}</Typography>
                                        <Typography variant="body2" color="text.secondary">Tipo: {tipoServicoLabel(os.tipoServico)}</Typography>
                                        <Typography variant="body2" color="text.secondary">Responsável: {os.responsavel?.nome || 'Não informado'}</Typography>
                                        {os.dataEmissao && (
                                            <Typography variant="body2" color="text.secondary">
                                                Emissão: {new Date(os.dataEmissao).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}
                                            </Typography>
                                        )}
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>

            {totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination count={totalPages} page={page} onChange={handleChange} color="primary" />
                </Box>
            )}
        </PageContainer>
    );
}

export default OS;
